import React from 'react'
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap'
import { Clock as IconClock } from 'react-feather'
import { Show } from '~/components/commons'

import { FormattedMessage, useIntl } from 'react-intl'
import { format } from 'date-fns'
import { ptBR, enUS } from 'date-fns/locale'

import Spinner from '~/components/@vuexy/spinner/Loading-spinner'
import { ContentText } from './styles'

function CovidPreviewModal({
  modalData = {},
  toggleModal,
  isOpen,
  onSubmit,
  isSubmiting,
}) {
  const { typeButton, urlCallToAction, postContent, schedule } = modalData

  const intl = useIntl()

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggleModal} className="modal-lg">
        <ModalHeader toggle={toggleModal} style={{ paddingLeft: '25px' }}>
          <FormattedMessage id="Preview COVID-19 update Post" />
        </ModalHeader>
        <ModalBody
          className="modal-dialog-centered"
          style={{ alignItems: 'stretch', padding: '25px' }}
        >
          <Show condition={isSubmiting}>
            <Spinner />
          </Show>
          <div className="w-100">
            <ContentText>
              <h4>
                <FormattedMessage id="Update your status" />:
              </h4>
              <p>{postContent}</p>
            </ContentText>
            <Show condition={typeButton}>
              <ContentText>
                <h4>
                  <FormattedMessage id="Button type" />:
                </h4>
                <p>{typeButton}</p>
              </ContentText>
            </Show>
            <Show condition={urlCallToAction}>
              <ContentText>
                <h4>URL:</h4>
                <p>{decodeURI(urlCallToAction)}</p>
              </ContentText>
            </Show>
          </div>
        </ModalBody>
        <ModalFooter
          className="d-flex justify-content-between"
          style={{ padding: '20px' }}
        >
          <div className="d-flex align-items-center">
            <IconClock size={33} className="mr-1" />
            <ContentText>
              <h4 className="mb-0">
                <FormattedMessage id="Published at" />:
              </h4>
              <p className="mb-0">
                {!schedule ? (
                  <FormattedMessage id="Now" />
                ) : (
                  format(schedule, 'Pp', {
                    locale: intl.locale === 'br' ? ptBR : enUS,
                  })
                )}
              </p>
            </ContentText>
          </div>
          <div className="d-flex">
            <Button
              outline
              color="primary"
              onClick={() => toggleModal(false)}
              disabled={isSubmiting}
            >
              <FormattedMessage id="Edit" />
            </Button>
            <Button
              color={schedule ? 'info' : 'success'}
              className="ml-2"
              onClick={onSubmit}
              disabled={isSubmiting}
            >
              <FormattedMessage
                id={`Confirm & ${schedule ? 'Schedule' : 'Update'}`}
              />
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default CovidPreviewModal
